import styled from 'styled-components';
import { FormGrid, FormGroup } from '../../../../style';

export const DimensionsGrid = styled(FormGrid)`
  margin-top: 16px;
`;

export const FullRowFormGroup = styled(FormGroup)`
  grid-column: span 3;
`;

export const CalcHint = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #696969;
`;

export const CalculatedValue = styled.div`
  display: flex;
  align-items: center;
  min-height: 42px;
  padding: 8px 12px;
  background: #f4f6f8;
  border: 1px solid #dfe3e8;
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  color: #1f2937;
`;
